//Types
export const Types = {
  GET_APP_CONFIG: "GET_APP_CONFIG",
  UPDATE_APP_CONFIG: "UPDATE_APP_CONFIG",
  GET_USER_VALIDATION_APP_CONFIG: "GET_USER_VALIDATION_APP_CONFIG",
  SET_LOADING: "SET_LOADING_APP_CONFIG",
  SET_LOADING_UPDATE: "SET_LOADING_UPDATE"
}

//Reducer
const initialState = {
  config: null,
  loading: false,
  updateLoading: false
}

const appConfig = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_APP_CONFIG:
      return {
        ...state,
        config: action.payload,
        loading: false
      }

    case Types.UPDATE_APP_CONFIG:
      return {
        ...state,
        config: action.payload,
        updateLoading: false
      }

    case Types.GET_USER_VALIDATION_APP_CONFIG:
      return {
        ...state,
        userValidation: action.payload,
        loading: false
      }

    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    case Types.SET_LOADING_UPDATE:
      return {
        ...state,
        updateLoading: true,
      }

    default:
      return state;
  }
}

export default appConfig;
